<app-confirm-card
  title="Exit?"
  message="Any unsaved changes will be discarded. This cannot be undone."
  icon="exit"
  cancelLabel="Go Back"
  confirmLabel="Yes, Exit"
  (confirm)="back()"
  (cancel)="cancel()"
></app-confirm-card>
